/**
 * Get user-friendly error message from error object
 * @param {Error} err - Error object
 * @returns {string} User-friendly error message
 */
export const getErrorMessage = (err) => {
  if (err.message?.includes("Template not found")) {
    return "The selected template could not be found. Please try selecting a different template.";
  } else if (err.message?.includes("Template JSON not found") || err.message?.includes("Template JSON is empty")) {
    return "The template is missing content. Please contact your administrator to fix this template.";
  } else if (err.message?.includes("Failed to convert JSON to HTML")) {
    return "The template format is invalid. Please contact your administrator to fix this template.";
  } else if (err.message?.includes("Client not found")) {
    return "Client information could not be retrieved. Please ensure the client exists.";
  } else if (err.message?.includes("Access denied")) {
    return "You don't have permission to access this template.";
  } else if (err.message?.includes("Invalid token") || err.message?.includes("401")) {
    return "Your session has expired. Please log in again.";
  } else if (err.message?.includes("Network Error") || err.message?.includes("Failed to fetch")) {
    return "Network error. Please check your connection and try again.";
  } else if (err.message?.includes("500")) {
    return "Server error. Please try again in a moment.";
  } else if (err.message) {
    return err.message;
  }
  return "An error occurred while generating the document. Please try again.";
};

/**
 * Get loading message based on retry state
 * @param {boolean} isRetrying - Whether currently retrying
 * @param {number} retryCount - Number of retry attempts
 * @returns {string} Loading message
 */
export const getLoadingMessage = (isRetrying, retryCount) => {
  if (isRetrying) {
    return `Retrying... (attempt ${retryCount + 1})`;
  }
  return "Generating document...";
}; 